import React from 'react';
import Truncate from 'react-truncate';

import { withStyles } from '@material-ui/core/styles';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import classnames from 'classnames';
import { ImgixDimensions } from 'constants/ui';
import { isNil, last, map, size, slice } from 'lodash';

import { AssignmentStatus } from 'pages/Students/shared';

import Flex from 'components/Flex';
import ImgixImage from 'components/ImgixImage';

import styles from './styles.module.scss';

const StyledCheckCircleRoundedIcon = withStyles({
  root: { color: 'var(--white)' }
})(CheckCircleRoundedIcon);

const TaskInfo = ({ task, img }) => {
  const getCriteria = () => {
    const criteriaSize = size(task.criteria);

    if (criteriaSize <= 3) return task.criteria;

    const visualizedCriteria = slice(task.criteria, 0, 2);
    return [
      ...visualizedCriteria,
      {
        name: `${criteriaSize - 2} more...`,
        value: false,
        id: last(visualizedCriteria).id + 100
      }
    ];
  };

  return (
    <div className={styles.taskInfoWrapper}>
      <div />

      <div className={styles.taskInfo}>
        <div
          className={classnames(styles.imgWrapper, {
            [styles.noImage]: isNil(img)
          })}
        >
          <AssignmentStatus
            className={styles.status}
            status={task.status}
            variant="light"
            hideText
          />
          {img && (
            <ImgixImage
              src={img}
              dimensions={ImgixDimensions.SMALL}
              className={styles.imgPreview}
              alt={`Student work for ${task.name}`}
            />
          )}
        </div>
        <div className={styles.info}>
          <h3 className={styles.taskName}>
            <Truncate key={task.name} lines={1}>
              {task.name}
            </Truncate>
          </h3>
          <div className={styles.criteria}>
            {map(getCriteria(), ({ id, name, value }) => (
              <Flex key={id} flexStart>
                <StyledCheckCircleRoundedIcon
                  disabled={isNil(value)}
                  fontSize="small"
                />
                <span className={styles.criteriaName}>{name}</span>
              </Flex>
            ))}
          </div>
        </div>
      </div>

      <div />
    </div>
  );
};

export default TaskInfo;
